import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  AutocompleteSelectInput,
  ConfirmActionModal,
  PageContentLayout,
} from '@tassomutuo-backoffice/ui';
import TeamDetails from './components/TeamDetails';
import TeamMembersTable from './components/TeamMembersTable';
import useTeamsDetailPage from './hooks/useTeamsDetailPage';
import TeamsDetailGroupSection from './components/TeamsDetailGroupSection';
import TeamGroupLeadersModal from './components/TeamGroupLeadersModal';
import TeamConfirmNotifyModal from './components/TeamConfirmNotifyModal';

const TeamsDetailPage = () => {
  const navigate = useNavigate();

  const {
    selectedTeam,
    selectedTeamOption,
    teamsSelectOptions,
    onChangeSelectedTeam,
    membersTableState,
    setMembersTableState,
    isPendingTeams,
    isPendingTeamMembers,
    teamMembersData,
    onCanReceiveLeadsCheckboxChange,
    onCanReceiveLeadsQuintoCheckboxChange,
    onCanReceiveLeadsPrestitoCheckboxChange,
    modalConfig,
    setModalState,
    createTeamGroup,
    isPendingTeamGroups,
    teamGroups,
    onTeamGroupChange,
    onRemoveMemberFromTeamGroup,
    onDeleteTeamGroup,
    modalManageGroupLeaders,
    setModalManageGroupLeaders,
    onRemoveMemberFromTeam,
    user,
    onConfirmSendAlertNotificationToMember,
    showModalAlertNotify,
    setShowModalAlertNotify,
  } = useTeamsDetailPage();

  const isAdmin = user?.role === 'admin';

  return (
    <>
      <PageContentLayout
        title="Dettaglio Team"
        error={null}
        isLoading={isPendingTeams}
      >
        {isAdmin && (
          <Box maxWidth="500px">
            <AutocompleteSelectInput
              label="Seleziona un team"
              selectOptions={teamsSelectOptions || []}
              value={selectedTeamOption}
              /* eslint-disable-next-line */
              // @ts-expect-error
              onChange={(
                event: React.SyntheticEvent,
                /* eslint-disable-next-line */
                value: any
              ) => {
                onChangeSelectedTeam(value);
              }}
            />
          </Box>
        )}
        {selectedTeam && (
          <>
            <TeamDetails
              team={selectedTeam}
              onNotifyTeamClick={() => setShowModalAlertNotify(true)}
            />
            <TeamMembersTable
              rowCount={teamMembersData?.totalResults || 0}
              isPending={isPendingTeamMembers}
              paginationModel={membersTableState.pagination}
              setPaginationModel={(paginationModel) =>
                setMembersTableState({
                  ...membersTableState,
                  pagination: paginationModel,
                })
              }
              users={teamMembersData?.results || []}
              onCanReceiveLeadsCheckboxChange={onCanReceiveLeadsCheckboxChange}
              onCanReceiveLeadsQuintoCheckboxChange={
                onCanReceiveLeadsQuintoCheckboxChange
              }
              onCanReceiveLeadsPrestitoCheckboxChange={
                onCanReceiveLeadsPrestitoCheckboxChange
              }
              teamGroups={teamGroups || []}
              onTeamGroupChange={onTeamGroupChange}
              onRemoveMemberFromTeamGroup={onRemoveMemberFromTeamGroup}
              onRemoveMemberFromTeam={onRemoveMemberFromTeam}
              disabled={!isAdmin}
              onConfirmSendAlertNotificationToMember={
                onConfirmSendAlertNotificationToMember
              }
            />
            <TeamsDetailGroupSection
              teamGroups={teamGroups || []}
              isPendingTeamGroups={isPendingTeamGroups}
              createTeamGroup={createTeamGroup}
              onDeleteTeamGroup={onDeleteTeamGroup}
              onManageGroupLeaders={setModalManageGroupLeaders}
              onViewGroupDetails={(group) => {
                navigate(`/admin/teams/${selectedTeam.id}/group/${group.id}`);
              }}
              disabled={!isAdmin}
            />
          </>
        )}
      </PageContentLayout>
      {modalConfig && (
        <ConfirmActionModal
          open
          title={modalConfig.title}
          description={modalConfig.description}
          handleClose={() =>
            setModalState({
              userToChangeCanReceiveLeads: null,
              userToChangeCanReceiveLeadsQuinto: null,
              userToChangeCanReceiveLeadsPrestito: null,
              addMemberToTeamGroup: null,
              removeMemberFromTeamGroup: null,
              removeTeamGroup: null,
              removeMemberFromTeam: null,
            })
          }
          onConfirm={modalConfig.onConfirm}
        />
      )}
      {modalManageGroupLeaders && (
        <TeamGroupLeadersModal
          handleClose={() => setModalManageGroupLeaders(null)}
          teamGroup={modalManageGroupLeaders}
          disabled={!isAdmin}
        />
      )}

      {showModalAlertNotify && selectedTeam && (
        <TeamConfirmNotifyModal
          open
          handleClose={() => setShowModalAlertNotify(false)}
          teamToNotify={selectedTeam}
        />
      )}
    </>
  );
};

export default TeamsDetailPage;
